<cap-rubrik [id]="item.id" [isClosable]="item.isClosable" [isOpen]="item.isOpen">
  <ng-container title>
    <h2 class="mb-0">{{ item.title | translate }}</h2>
  </ng-container>
  @switch (item.element) {
    @case ("detailGrundstueckBeschreibung") {
      <cap-grundstueck-beschreibung
        [gsId]="grundstueck.id"
        [hasRight]="grundstueck?.permissions?.beschreibung && grundstueck?.permissions?.beschreibungErsterfassungUebergeben">
      </cap-grundstueck-beschreibung>
    }
    @case ("detailGrundstueckEigentum") {
      <cap-eigentum-table
        [hasRight]="grundstueck?.permissions?.eigentum && eigentumErsterfassungUebergeben"
        [listLoader]="eigentumLoader"
        [showAdressen]="false">
      </cap-eigentum-table>
    }
    @case ("detailGrundstueckGeschaefteAuftraege") {
      <cap-grundstueck-haengige
        [grundstueckId]="grundstueck.id"
        [hasRight]="grundstueck?.permissions?.haengigeGeschaefte"
        [loadOption]="loadOption">
      </cap-grundstueck-haengige>
    }
    @case ("detailGrundstueckDienstbarkeiten") {
      <cap-standardrecht-table
        [hasRight]="grundstueck?.permissions?.dienstbarkeiten && dienstbarkeitErsterfassungUebergeben"
        [listLoader]="dienstbarkeitListLoader">
      </cap-standardrecht-table>
    }
    @case ("detailGrundstueckGrundlasten") {
      <cap-standardrecht-table
        [hasRight]="grundstueck?.permissions?.grundlasten && grundlastErsterfassungUebergeben"
        [listLoader]="grundlastListLoader">
      </cap-standardrecht-table>
    }
    @case ("detailGrundstueckVormerkungen") {
      <cap-standardrecht-table
        [hasRight]="grundstueck?.permissions?.vormerkungen && vormerkungErsterfassungUebergeben"
        [listLoader]="vormerkungListLoader">
      </cap-standardrecht-table>
    }
    @case ("detailGrundstueckRangregelungen") {
      <cap-rangregelung-table [hasRight]="grundstueck?.permissions?.rangregelungen" [listLoader]="rangregelungListLoader">
      </cap-rangregelung-table>
    }
    @case ("detailGrundstueckAnmerkungen") {
      @if (showLableNichtOeffentlicheAnmerkungen && grundstueck?.permissions?.anmerkungen) {
        <div class="text-nowrap mt-1"><i class="fas fa-info-circle"></i> {{ "NurOeffentlicheAnmerkungenWerdenAngezeigt" | translate }}</div>
      }
      <cap-standardrecht-table
        [hasRight]="grundstueck?.permissions?.anmerkungen && anmerkungErsterfassungUebergeben"
        [listLoader]="anmerkungListLoader">
      </cap-standardrecht-table>
    }
    @case ("detailGrundstueckGrundpfandrechte") {
      <cap-grundpfandrecht-table
        [hasRight]="grundstueck?.permissions?.grundpfandrecht && grundpfandrechErsterfassungUebergeben"
        [listLoader]="grundpfandrechteListLoader">
      </cap-grundpfandrecht-table>
    }
  }

  @if (item.element === "detailGrundstueckGeschaefteAuftraege") {
    <div class="btn-group btn-group-sm float-end" data-toggle="buttons" titleActionButtons>
      <label [ngClass]="{ active: loadOption == 'HAENGIGE' }" class="btn btn-outline-secondary">
        <input
          (click)="setLoadOptions('HAENGIGE')"
          autocomplete="off"
          checked="loadOption == 'HAENGIGE'"
          class="btn-check"
          id="haengig"
          name="loadOption"
          type="radio" />
        {{ "HAENGIGE" | translate }}
      </label>
      <label [ngClass]="{ active: loadOption == 'ALLE' }" class="btn btn-outline-secondary">
        <input
          (click)="setLoadOptions('ALLE')"
          autocomplete="off"
          checked="loadOption == 'ALLE'"
          class="btn-check"
          id="alle"
          name="loadOption"
          type="radio" />
        {{ "ALLE" | translate }}
      </label>
    </div>
  }
</cap-rubrik>
